// Pure helpers for the Gate-4 composition (stacked-bar) chart — no React, fully unit-testable.

// Headroom so a non-breaching bar never fills the track completely and a breach still extends past
// its limit tick.
const HEADROOM = 1.05;

// UND-805 #3: ONE scale shared by every radius bar in a cluster, so equal dollars render at equal
// width and the Table-1 limit ticks step rightward (25 -> 30 -> 35 -> 40M). Anchored to the largest
// limit, or the largest accumulation when a breach runs past it. Previously each bar normalized to
// its own limit, so a fixed dollar amount looked like a different fraction on every row.
export const clusterDenom = (rows) => {
  let max = 0;
  (rows || []).forEach((r) => {
    const limit = Number(r.limit) || 0;
    const total = Number(r.total) || 0;
    if (limit > max) max = limit;
    if (total > max) max = total;
  });
  return max > 0 ? max * HEADROOM : 1;
};
